// src/components/Banner.js
import React, { useEffect, useState } from 'react';
import './Banner.css';
import logo from '../assets/images/owl-transparent.png';
import { FaInstagram, FaFacebook, FaYoutube, FaTwitter, FaTiktok, FaBars, FaTimes } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

const Banner = () => {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
    useEffect(() => {
        // Text effect for navigation items only
        const navItems = document.querySelectorAll('.capabilities-nav li a');
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890!?$#%+-_/|<>";
        
        navItems.forEach((item) => {
            // Calculate and store the original width of each navigation item
            const originalWidth = item.offsetWidth;
            item.style.display = 'inline-block';
            item.style.width = `${originalWidth}px`;
            
            item.addEventListener('mouseover', (event) => {
                let iteration = 0;
                const originalText = event.target.dataset.value;
                
                clearInterval(event.target._interval);
                
                event.target._interval = setInterval(() => {
                    event.target.innerText = event.target.innerText
                        .split("")
                        .map((letter, index) => {
                            if(index < iteration) {
                                return originalText[index];
                            }
                            return letters[Math.floor(Math.random() * letters.length)];
                        })
                        .join("");
                    
                    if(iteration >= originalText.length) {
                        clearInterval(event.target._interval);
                    }
                    
                    iteration += 1 / 3;
                }, 30);
            });
        });
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <div className="capabilities-banner">
            {/* Desktop Navigation */}
            <div className="desktop-banner">
                <div className="capabilities-banner-left-content">
                    <Link to="/" className="company-title-link">
                        <span className="capabilities-company-name">Hidden Capabilities</span>
                    </Link>
                    <Link to="/" className="logo-link">
                        <img src={logo} alt="Company Logo" className="capabilities-logo" />
                    </Link>
                    
                    <div className="navigation-container">
                        <nav className="capabilities-nav">
                            <ul>
                                <li className={location.pathname === '/thermals' ? 'active' : ''}>
                                    <Link to="/thermals" data-value="Thermals">Thermals</Link>
                                </li>
                                <li className={location.pathname === '/night-vision' ? 'active' : ''}>
                                    <Link to="/night-vision" data-value="Night Vision">Night Vision</Link>
                                </li>
                                <li className={location.pathname === '/pricing' ? 'active' : ''}>
                                    <Link to="/pricing" data-value="Pricing">Pricing</Link>
                                </li>
                                <li className={location.pathname === '/about' ? 'active' : ''}>
                                    <Link to="/about" data-value="About Us">About Us</Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    
                    <div className="social-media-icons">
                        <a href="https://www.instagram.com/hidden.capabilities/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <FaInstagram className="social-icon" />
                        </a>
                        <a href="https://www.facebook.com/hiddencapabilities" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <FaFacebook className="social-icon" />
                        </a>
                        <a href="https://www.youtube.com/@Hidden-Capabilities" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <FaYoutube className="social-icon" />
                        </a>
                        <a href="https://x.com/HCapabilities" target="_blank" rel="noopener noreferrer" aria-label="X">
                            <FaTwitter className="social-icon" />
                        </a>
                        <a href="https://www.tiktok.com/@hiddencapabilities" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                            <FaTiktok className="social-icon" />
                        </a>
                    </div>
                </div>

                <div className="capabilities-left-triangle"></div>
                <div className="capabilities-right-triangle"></div>
            </div>

            {/* Mobile Navigation */}
            <div className="mobile-banner">
                <div className="mobile-header">
                    <div className="mobile-brand-container">
                        <Link to="/" className="mobile-company-title-link">
                            <span className="capabilities-company-name">Hidden Capabilities</span>
                        </Link>
                        <Link to="/" className="mobile-logo-link">
                            <img src={logo} alt="Company Logo" className="capabilities-logo" />
                        </Link>
                    </div>
                    <button 
                        className="mobile-menu-toggle" 
                        onClick={toggleMobileMenu}
                        aria-label="Toggle mobile menu"
                    >
                        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                    <nav className="mobile-nav">
                        <ul>
                            <li className={location.pathname === '/thermals' ? 'active' : ''}>
                                <Link to="/thermals" onClick={closeMobileMenu}>Thermals</Link>
                            </li>
                            <li className={location.pathname === '/night-vision' ? 'active' : ''}>
                                <Link to="/night-vision" onClick={closeMobileMenu}>Night Vision</Link>
                            </li>
                            <li className={location.pathname === '/pricing' ? 'active' : ''}>
                                <Link to="/pricing" onClick={closeMobileMenu}>Pricing</Link>
                            </li>
                            <li className={location.pathname === '/about' ? 'active' : ''}>
                                <Link to="/about" onClick={closeMobileMenu}>About Us</Link>
                            </li>
                        </ul>
                    </nav>
                    
                    <div className="mobile-social-media-icons">
                        <a href="https://www.instagram.com/hidden.capabilities/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <FaInstagram className="social-icon" />
                        </a>
                        <a href="https://www.facebook.com/hiddencapabilities" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <FaFacebook className="social-icon" />
                        </a>
                        <a href="https://www.youtube.com/@Hidden-Capabilities" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <FaYoutube className="social-icon" />
                        </a>
                        <a href="https://x.com/HCapabilities" target="_blank" rel="noopener noreferrer" aria-label="X">
                            <FaTwitter className="social-icon" />
                        </a>
                        <a href="https://www.tiktok.com/@hiddencapabilities" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                            <FaTiktok className="social-icon" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;